import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { headerStore, projectsDataStore, userInfoStore } from "../../Stores";
import { sidebarStore } from "./Sidebar/SidebarStore";
import { BarsIcon } from "./Sidebar/BarsIcon";
import classNames from "classnames";

export const CustomerLogo = observer(() => {
  const [isInProject, setIsInProject] = React.useState(false);
  const cName = classNames("logo-wrapper");
  const location = useLocation();

  React.useEffect(() => {
    setIsInProject(location.pathname.indexOf("/project/") !== -1);
  }, [location]);

  if (headerStore.logo) {
    return (
      <div className={cName}>
        {isInProject && <BarsIcon isOpen={!sidebarStore.isCollapsed} onClick={sidebarStore.toggleSidebar} />}
        <Link to="/" className="custom-logo">
          <img src={headerStore.logo} alt="logo" />
        </Link>
      </div>
    );
  } else {
    return (
      <div className={cName}>
        {isInProject && <BarsIcon isOpen={!sidebarStore.isCollapsed} onClick={sidebarStore.toggleSidebar} />}
        <Link to="/" className="logo" />
      </div>
    );
  }
});

export const CustomerText = observer(
  class CustomerText extends React.Component<{ style?: React.CSSProperties }> {
    renderHeaderText = (response: API_LogoTextData) => {
      const { title, email, phone } = response;
      return (
        <div className="customer-header-text">
          {title && <span className="customer-header-text--title">{title}</span>}
          <div className="customer-header-text--value">
            {phone && (
              <span>
                <span className="customer-header-text--label">Tel.:</span>
                {phone}
              </span>
            )}
            {email && (
              <span className="customer-header-text--label-margin">
                <span className="customer-header-text--label">E-mail:</span>
                {email}
              </span>
            )}
          </div>
        </div>
      );
    };

    render() {
      const { style } = this.props;
      const isGuestTenderPage = window.location.pathname.indexOf("guest") !== -1 || userInfoStore.role === "GUEST";
      const isProjectTextData = projectsDataStore?.currentProject?.logoTextData;
      if (isGuestTenderPage) {
        const textData: API_LogoTextData = {
          email: "support@pmgnet.de",
          phone: "+49 89 330 37 82-100",
          title: `Support`,
        };
        return (
          <div className="logo-text-wrapper" style={style}>
            {this.renderHeaderText(textData)}
          </div>
        );
      }

      if (isProjectTextData) {
        return (
          <div className="logo-text-wrapper" style={style}>
            {this.renderHeaderText(isProjectTextData)}
          </div>
        );
      }

      return null;
    }
  }
);
